/**
 * useLeaveDashboard Hook
 *
 * Fetches leave dashboard summary data with real-time Mercure updates.
 *
 * Features:
 * - Aggregated dashboard data for the conges tab
 * - Real-time updates via Mercure
 * - Automatic caching with 5-minute stale time
 * - Auto-refresh every 2 minutes
 */

import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { API_ENDPOINTS } from "../../config/constants";
import type { CongesDashboardSummary } from "../types";
import { congesDashboardQueryKeys } from "./congesDashboardQueryKeys";

/**
 * Hook to fetch leave dashboard summary data
 */
export function useLeaveDashboard() {
  // Mercure subscription lives in lib/config/mercureSubscriptions.ts
  // (topic: /api/dashboard/conges) so invalidation works app-wide.

  return useQuery<CongesDashboardSummary>({
    queryKey: congesDashboardQueryKeys.summary(),
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.DASHBOARD_CONGE);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 2 * 60 * 1000, // Refresh every 2 minutes
  });
}
